import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {LEGACY_FONT_PROXIMA_TITLE} from 'styles/FontConstants';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import {GRAY_DARK} from 'ui-library/Colors';

export default function AnalyticsDashboardReadOnlyInfo(): JSX.Element {
  const readOnlyInfo = 'Changes will not be saved. For edit access please contact the project owner.';
  return (
    <span className={classNames('u-cursor-default', css(styles.info))}>
      <Tooltip title={readOnlyInfo} placement={TooltipPlacement.BOTTOM}>
        <span>Read-only</span>
      </Tooltip>
    </span>
  );
}

const styles = StyleSheet.create({
  info: {
    color: GRAY_DARK,
    ...LEGACY_FONT_PROXIMA_TITLE,
  },
});
